import { useState } from "react";


const TabBottom = (props: any) => {
    let des = props?.des
    // let shortDes = props?.shortDes
    let tokenMetrics = props?.tokenMetrics
    let roadmap = props?.roadmap
    let partner = props?.partner
    let team = props?.team

    const [tab, setTab] = useState(0)

    function handleSelectTab(arg0: number) {
        setTab(arg0)
    }
    return (
        <>
            <div className="list-tab-bottom">
                <div className="tabs-bottom">
                    <div
                        onClick={() => handleSelectTab(0)}
                        className={`tab-bottom ${tab === 0 ? 'active' : ''}`}
                    >DESCRIPTION
                    </div>
                    <div
                        onClick={() => handleSelectTab(1)}
                        className={`tab-bottom ${tab === 1 ? 'active' : ''}`}
                    >Roadmap
                    </div>
                    <div
                        onClick={() => handleSelectTab(2)}
                        className={`tab-bottom ${tab === 2 ? 'active' : ''}`}
                    >Team
                    </div>
                    <div
                        onClick={() => handleSelectTab(3)}
                        className={`tab-bottom ${tab === 3 ? 'active' : ''}`}
                    >Partner&Investor
                    </div>
                    <div
                        onClick={() => handleSelectTab(4)}
                        className={`tab-bottom ${tab === 4 ? 'active' : ''}`}
                    >Token Metrics
                    </div>
                </div>
                {tab === 0 && (
                    <div className="content-tab0">
                        <div className="dec-tab0">
                            <div
                                dangerouslySetInnerHTML={{ __html: des }}
                            />
                        </div>
                    </div>
                )}
                {tab === 1 && (
                    <div className="content-tab0">
                        <div className="dec-tab0">
                            <div
                                dangerouslySetInnerHTML={{ __html: roadmap }}
                            />
                        </div>
                    </div>
                )}
                {tab === 2 && (
                    <div className="content-tab0">
                        <div className="dec-tab0">
                            <div
                                dangerouslySetInnerHTML={{ __html: team }}
                            />
                        </div>
                    </div>
                )}
                {tab === 3 && (
                    <div className="content-tab0">
                        <div className="dec-tab0">
                            <div
                                dangerouslySetInnerHTML={{ __html: partner }}
                            />
                        </div>
                    </div>
                )}
                {tab === 4 && (
                    <div className="content-tab0">
                        <div className="dec-tab0">
                            <div
                                dangerouslySetInnerHTML={{ __html: tokenMetrics }}
                            />
                        </div>
                    </div>
                )}

            </div>
        </>
    )
}

export default TabBottom;